/* BrandNest Market 5.0.0 | Progressive enhancement.
   Product, cart, search and localization forms still work without this file. */
(() => {
  'use strict';
  const configElement = document.getElementById('BNConfig');
  if (!configElement) return;
  let cfg;
  try { cfg = JSON.parse(configElement.textContent); } catch { return; }
  const drawer = document.getElementById('BNCartDrawer');
  const stringKeys = { add:'add', adding:'adding', added:'added', soldOut:'sold_out', inStock:'in_stock', error:'cart_error', network:'network_error', remove:'remove', empty:'cart_empty', quantity:'quantity', copied:'copied' };
  const strings = new Proxy(cfg.strings || {}, { get(target, name) { return window.BNLanguage?.uiOnly && stringKeys[name] ? window.BNLanguage.t(stringKeys[name]) : target[name]; } });
  let lastCartTrigger = null;
  let cartBusy = false;
  const variantRequests = new Map();
  const isStandardClick = event => !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0;
  const money = (amount, currency = cfg.currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || cfg.locale, { style: 'currency', currency }).format(Number(amount) / 100); }
    catch { return `${(Number(amount) / 100).toFixed(2)} ${currency || ''}`; }
  };
  function element(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function safeUrl(url) {
    try {
      const parsed = new URL(url, location.origin);
      return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : '';
    } catch { return ''; }
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', ...options,
        headers: { Accept: 'application/json', ...(options.headers || {}) },
        signal: options.signal || controller.signal
      });
      let data;
      try { data = await response.json(); } catch { throw new Error(strings.error); }
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : strings.error);
      return data;
    } finally { clearTimeout(timer); }
  }
  function setCounts(count) {
    document.querySelectorAll('[data-bn-cart-count]').forEach(el => { el.textContent = String(count); });
  }
  function renderCart(cart) {
    setCounts(cart.item_count);
    if (!drawer) return;
    const list = drawer.querySelector('[data-cart-items]');
    list.replaceChildren();
    if (!cart.items.length) {
      list.append(element('p', 'bn-empty', strings.empty));
    }
    for (const item of cart.items) {
      const row = element('article', 'bn-drawer-item');
      const imageLink = element('a');
      imageLink.href = safeUrl(item.url);
      imageLink.setAttribute('aria-label', item.product_title || item.title);
      if (item.image) {
        const image = element('img');
        image.src = safeUrl(item.image);
        image.alt = item.product_title || item.title;
        image.width = 78; image.height = 78; image.loading = 'lazy';
        imageLink.append(image);
      }
      row.append(imageLink);
      const body = element('div');
      const h3 = element('h3');
      const productLink = element('a', '', item.product_title || item.title);
      productLink.href = safeUrl(item.url);
      h3.append(productLink); body.append(h3);
      if (item.variant_title && item.variant_title !== 'Default Title') body.append(element('p', '', item.variant_title));
      body.append(element('p', '', `${strings.quantity}: ${item.quantity}`));
      const price = element('strong');
      price.append(element('bdi', '', money(item.final_line_price, cart.currency)));
      body.append(price);
      const remove = element('button', '', strings.remove);
      remove.type = 'button'; remove.dataset.cartRemove = item.key;
      remove.setAttribute('aria-label', `${strings.remove}: ${item.product_title || item.title}`);
      body.append(remove); row.append(body); list.append(row);
    }
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    drawer.querySelector('[data-drawer-checkout]').disabled = cart.item_count === 0;
  }
  function clearDrawerError() { if (drawer) drawer.querySelector('[data-cart-error]').textContent = ''; }
  async function refreshCart() {
    const cart = await request(cfg.cartJson);
    renderCart(cart); return cart;
  }
  function revealDrawer(trigger) {
    if (!drawer || typeof drawer.showModal !== 'function') return false;
    lastCartTrigger = trigger || document.activeElement;
    if (!drawer.open) drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  function closeDrawer() {
    if (drawer?.open) drawer.close();
  }
  drawer?.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
    if (lastCartTrigger?.isConnected) lastCartTrigger.focus();
  });
  drawer?.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const r = drawer.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDrawer();
  });
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-cart-close]');
    if (close) { closeDrawer(); return; }
    const cartLink = event.target.closest('[data-cart-open]');
    if (cartLink && isStandardClick(event) && drawer && typeof drawer.showModal === 'function') {
      event.preventDefault(); clearDrawerError();
      if (cartBusy) return;
      cartBusy = true; cartLink.setAttribute('aria-busy', 'true');
      try { await refreshCart(); revealDrawer(cartLink); }
      catch { location.href = cfg.cartUrl; }
      finally { cartBusy = false; cartLink.removeAttribute('aria-busy'); }
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && !cartBusy) {
      cartBusy = true; remove.disabled = true; clearDrawerError();
      try {
        const cart = await request(cfg.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 }) });
        renderCart(cart);
        drawer.querySelector('[data-cart-close]')?.focus();
      } catch (error) {
        drawer.querySelector('[data-cart-error]').textContent = error.message || strings.error;
        remove.disabled = false;
      } finally { cartBusy = false; }
      return;
    }
    const quantityButton = event.target.closest('[data-quantity-step]');
    if (quantityButton) {
      const input = quantityButton.closest('.bn-quantity')?.querySelector('input');
      if (!input) return;
      try {
        if (Number(quantityButton.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch { /* The native numeric field remains usable. */ }
      return;
    }
    const mediaLink = event.target.closest('[data-media-target]');
    if (mediaLink && isStandardClick(event)) {
      const section = mediaLink.closest('[data-product-section]');
      const target = section?.querySelector(`[data-media-id="${CSS.escape(mediaLink.dataset.mediaTarget)}"]`);
      if (!target) return;
      event.preventDefault();
      section.querySelectorAll('[data-media-id]').forEach(slide => {
        slide.hidden = slide !== target;
        if (slide !== target) slide.querySelectorAll('video').forEach(video => video.pause());
        if (slide !== target) slide.querySelectorAll('iframe').forEach(frame => {
          try { frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*'); frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*'); } catch { /* External embeds are isolated. */ }
        });
      });
      section.querySelectorAll('[data-media-target]').forEach(link => link.setAttribute('aria-current', String(link === mediaLink)));
      return;
    }
    const optionLink = event.target.closest('[data-option-link]');
    if (optionLink && isStandardClick(event)) {
      const section = optionLink.closest('[data-product-section]');
      if (!section) return;
      const targetUrl = new URL(optionLink.href);
      if (targetUrl.origin !== location.origin) return;
      event.preventDefault();
      const sectionId = section.dataset.sectionId;
      variantRequests.get(sectionId)?.abort();
      const controller = new AbortController();
      variantRequests.set(sectionId, controller);
      section.setAttribute('aria-busy', 'true');
      const fetchUrl = new URL(targetUrl);
      fetchUrl.searchParams.set('section_id', sectionId);
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(fetchUrl, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Product section unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('[data-product-section]');
        if (!replacement) throw new Error('Product section missing');
        if (variantRequests.get(sectionId) !== controller) return;
        section.replaceWith(replacement);
        history.replaceState({}, '', targetUrl);
        replacement.querySelector(`[data-option-id="${CSS.escape(optionLink.dataset.optionId)}"]`)?.focus({ preventScroll: true });
        if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
      } catch (error) {
        if (variantRequests.get(sectionId) === controller) location.href = targetUrl.href;
      } finally {
        clearTimeout(timeout);
        if (variantRequests.get(sectionId) === controller) variantRequests.delete(sectionId);
        section.removeAttribute('aria-busy');
      }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.bn-product-form')) return;
    if (!form.checkValidity()) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = form.querySelector('[name="add"]');
    if (!button || button.disabled) return;
    const status = form.querySelector('.bn-form-status');
    const label = button.querySelector('span');
    form.dataset.submitting = 'true'; button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.classList.remove('is-error'); status.textContent = '';
    if (label) label.textContent = strings.adding;
    try {
      await request(cfg.cartAdd, { method: 'POST', body: new FormData(form) });
      status.textContent = strings.added;
      const link = form.querySelector('.bn-added-link');
      if (link) link.hidden = false;
      try { clearDrawerError(); await refreshCart(); revealDrawer(button); }
      catch { /* Addition succeeded. The native cart link stays visible if refresh fails. */ }
    } catch (error) {
      status.textContent = error.message || strings.network;
      status.classList.add('is-error');
    } finally {
      button.disabled = false; button.removeAttribute('aria-busy');
      if (label) label.textContent = strings.add;
      delete form.dataset.submitting;
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort]')) event.target.form?.requestSubmit();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bn-nav-dropdown[open],.bn-filter-panel[open]').forEach(details => {
      details.open = false; details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.bn-nav-dropdown[open],.bn-filter-panel[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  function loadRecommendations(root = document) {
    root.querySelectorAll('[data-product-recommendations]').forEach(node => {
      if (node.dataset.loaded || !node.dataset.url) return;
      node.dataset.loaded = 'true';
      const load = async () => {
        try {
          const response = await fetch(node.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) return;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = page.querySelector('[data-product-recommendations]');
          if (content?.querySelector('.bn-card')) node.replaceChildren(...content.childNodes);
        } catch { /* Recommendations are optional. The product page remains usable. */ }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '300px' });
        observer.observe(node);
      } else load();
    });
  }
  document.addEventListener('brandnest:languagechange', () => { if (drawer?.open) refreshCart().catch(() => {}); });
  loadRecommendations();
  document.addEventListener('shopify:section:load', event => loadRecommendations(event.target));
})();
